import { defineAsyncComponent } from 'vue'
export default {
  default: defineAsyncComponent(() => import("/Users/sebasgona/sga/pinturas-granados/granados/app/layouts/default.vue").then(m => m.default || m))
}